import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import DataTable from "examples/Tables/DataTable";
import Checkbox from "@mui/material/Checkbox";
import MDBadge from "components/MDBadge";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

function PolicyItemsTableData({ data, selectedIds, onToggle, onEdit, onDelete }) {
  const columns = [
    { Header: "#", accessor: "checkbox", align: "center", width: "2%" },
    { Header: "Code", accessor: "code", align: "left" },
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Group", accessor: "itemGroup", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "% by Company", accessor: "percentageByCompany", align: "center" },
    { Header: "% by Beneficiary", accessor: "percentageByBeneficiary", align: "center" },
    { Header: "Old Id", accessor: "oldId", align: "left" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = (data || []).map((a) => ({
    checkbox: (
      <Checkbox size="small" checked={selectedIds.includes(a.id)} onChange={() => onToggle(a.id)} />
    ),
    code: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.code}
      </MDTypography>
    ),
    name: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.name}
      </MDTypography>
    ),
    itemGroup: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.itemGroup}
      </MDTypography>
    ),
    status: (
      <MDBadge
        badgeContent={a.status}
        size="md"
        container
        // optional: color mapping
        color={String(a.status).toLowerCase() === "active" ? "success" : "secondary"}
      />
    ),
    percentageByCompany: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.percentageByCompany}
      </MDTypography>
    ),
    percentageByBeneficiary: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.percentageByBeneficiary}
      </MDTypography>
    ),
    oldId: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.oldId}
      </MDTypography>
    ),
    action: (
      <div>
        <IconButton size="small" onClick={() => onEdit(a)}>
          <EditIcon fontSize="small" />
        </IconButton>
        <IconButton size="small" color="error" onClick={() => onDelete(a)}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </div>
    ),
  }));

  return (
    <DataTable
      table={{ columns, rows }}
      isSorted
      entriesPerPage={false}
      showTotalEntries={false}
      noEndBorder
      canSearch={false}
      size="small"
    />
  );
}

PolicyItemsTableData.propTypes = {
  data: PropTypes.array.isRequired,
  selectedIds: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default PolicyItemsTableData;
